import React, { useState } from 'react';
import proptypes from 'prop-types';
const { string, arrayOf, shape, func, bool } = proptypes;
import { Tab, Tabs } from '@one-thd/sui-atomic-components';

const VisualTabs = (props) => {
  const {
    categories, products, filterItemIds
  } = props;
  const [categoryTabValue, setCategoryTabValue] = useState(0);

  let tabCategories = [];

  const productItemIds = products?.length > 0 ? products?.map((product) => product?.product?.itemId) : [];
  // Add an "all" category
  const categoriesIncludingAll = [{
    category: 'All Items',
    subCategory: 'All Items',
    itemIds: productItemIds
  }, ...categories];

  categoriesIncludingAll.forEach((category) => {
    tabCategories.push({
      subCategory: `${category.category}`,
      itemIds: category.itemIds
    });
  });

  const onCategoryTabSelectedChange = (event, index) => {
    setCategoryTabValue(index);
  };

  const setCategoryProductsIds = (itemIds) => {
    let categoryProducts = products?.filter((product) => itemIds.includes(product?.product?.itemId));
    filterItemIds(categoryProducts);
  };

  return (
    <>
      <Tabs
        value={categoryTabValue}
        onChange={onCategoryTabSelectedChange}
        aria-label="visualTabs"
        variant="scrollable"
      >
        {tabCategories?.map((category, index) => {
          return (
            <Tab
              label={category.subCategory}
              key={index}
              onClick={() => { setCategoryProductsIds(category.itemIds); }}
            />
          );
        })}
      </Tabs>
    </>
  );
};

VisualTabs.propTypes = {
  categories: arrayOf(shape({
    category: string,
    itemIds: arrayOf
  })),
  products: arrayOf(shape({
    product: shape({
      itemId: string
    })
  })),
  filterItemIds: func
};

VisualTabs.defaultProps = {
  categories: {
    category: null,
    itemIds: null,
    products: null
  },
  products: {
    product: {
      itemId: null
    }
  },
  filterItemIds: null
};

export { VisualTabs };
